import { Component, OnInit } from '@angular/core';
import {WidgetBaseGridComponent} from '../widget-base/widget-base-grid.component';
import {DoraProperty} from '../../Decorators/Decorator';
import {MessageColumnsVisible} from '../../messages/message-columns-visible';

@Component({
  selector: 'dora-column-paginator',
  templateUrl: './dora-column-paginator.component.html',
  styleUrls: ['./dora-column-paginator.component.scss']
})
export class DoraColumnPaginatorComponent extends WidgetBaseGridComponent {
  @DoraProperty
  private fixedColumn = 2;

  @DoraProperty
  private floatColumn = 4;

  @DoraProperty
  private flInitialPositionOnLast = false;

  private pagesNumber: number;
  private currentPage: number;

  protected onNewData(): void {
    super.onNewData();

    // perform pages variables
    this.pagesNumber = Math.ceil ((this.dataGrid.tuplasDescription.length - this.fixedColumn) / this.floatColumn);

    // set current page
    this.currentPage = this.flInitialPositionOnLast ? this.pagesNumber - 1 : 0;

    this.setActiveColumns();
  }

  private getPagesIdx(): number[] {
    return new Array(this.pagesNumber);
  }

  private setActiveColumns(): void {
    this.dataGrid.setAllColumnsInvisible();

    // set fixed column
    let idx = 0;
    for (idx = 0; idx < this.fixedColumn; idx++) {
      this.dataGrid.tuplasDescription[idx].visible = true;
    }

    // set current page
    const start = this.fixedColumn + (this.currentPage * this.floatColumn);
    let end = start + this.floatColumn;
    if (end > this.dataGrid.tuplasDescription.length) {
      end = this.dataGrid.tuplasDescription.length;
    }
    for (idx = start; idx < end; idx++) {
      this.dataGrid.tuplasDescription[idx].visible = true;
    }

    this.messageService.sendMessage(this.EventChannel,
        new MessageColumnsVisible(this.dataGrid.getColumnsVisible()), this.CallerName);
  }

  private getPageClass(pageNumber: number): string {
    let result = 'DAG-page-element';

    if (pageNumber === this.currentPage) {
      result += ' selected';
    } else {
      result += ' unselected';
    }
    return result;
  }

  private onPageSelected(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.setActiveColumns();
  }
}

